// extracted by mini-css-extract-plugin
module.exports = {"swiper":"Swiper_swiper__2jRXu","swiperc1":"Swiper_swiperc1__2oPcq","swiperc2":"Swiper_swiperc2__EUAWt","swiperc3":"Swiper_swiperc3__2ijMp"};